import React from 'react'

import CloseButton from '../CloseButton'

import useStyles from './styles'

const Image = ({ file, onDelete }) => {
  const [src, setSrc] = React.useState('')
  const [hovering, setHovering] = React.useState(false)

  const classes = useStyles()

  // Create preview image
  React.useEffect(() => {
    if (file) {
      setSrc(URL.createObjectURL(file))
    }
  }, [file])

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={classes.root}
    >
      <img src={src} alt='' className={classes.image} />

      {hovering && <CloseButton onDelete={onDelete} />}
    </div>
  )
}

export default Image
